// import './external/global.js';
import './main/external/forms/index.js';
import './main/app.js';
